import React from 'react';
import TaskDefensePlanner from '../features/taskDefense/TaskDefensePlanner';

const TaskDefensePage = () => {
  return <TaskDefensePlanner />;
};

export default TaskDefensePage;


